<template>
  <!--übergibt das Aktuelle Datum in der Form jjjj-mm-dd -->
  <ThemenBearbeiten
    v-if="date"
    :current-date="date"
  />
</template>

<script>
import ThemenBearbeiten from "../../components/Themen/ThemenBearbeiten.vue";
export default {
  components: {
    ThemenBearbeiten
  },
  data: () => ({
    date: null
  }),

  mounted() {
    this.$store.commit("title", "Themen bearbeiten");
    const current = new Date();
    let date = `${current.getFullYear()}`;
    if (current.getMonth() + 1 < 10)
      date = date + `-0${current.getMonth() + 1}`;
    else date = date + `-${current.getMonth() + 1}`;
    if (current.getDate() < 10) date = date + `-0${current.getDate()}`;
    else date = date + `-${current.getDate()}`;
    this.date = date;
  }
};
</script>
